
import React from 'react';
import ChatbotAvatar from './ChatbotAvatar';

interface ChatbotButtonProps {
  onClick: () => void;
}

const ChatbotButton: React.FC<ChatbotButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="chatbot-button shadow-lg hover:bg-primary/90 transition-all duration-300"
      aria-label="Open chat"
      style={{ height: '6rem', width: '6rem' }}
    >
      <ChatbotAvatar size="large" />
    </button>
  );
};

export default ChatbotButton;
